import { faker } from '@faker-js/faker'

import { getServiceOffer } from './ServiceOffer'

import { HospitalCountry } from '../../contracts/hospital'
import { ApprovalProcessReviewerView, ApprovalProcessStatus, Status } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'
import { ExtraPriceChargeType, ExtraPriceType } from '../../contracts/service-offer/AdminServiceOfferExtraPrice'

export const getApprovalProcessReviewerView = asBuilder(
  (): ApprovalProcessReviewerView => ({
    approvalProcessId: faker.number.int(),
    status: faker.helpers.enumValue(ApprovalProcessStatus),
    processStatusChangedAtUtc: '2021-01-01T00:00:00',
    reasonForProcessStatusChange: faker.lorem.sentence(),
    approverName: faker.person.firstName(),
    memo: faker.lorem.sentence(),

    hospital: {
      id: faker.number.int(),
      name: faker.company.name(),
      country: faker.helpers.enumValue(HospitalCountry),
    },
    extraPrices: faker.helpers.multiple(
      () => ({
        type: faker.helpers.enumValue(ExtraPriceType),
        chargeType: faker.helpers.enumValue(ExtraPriceChargeType),
        amount: faker.number.int({ min: 1, max: 1000000 }),
      }),
      {
        count: {
          min: 1,
          max: 10,
        },
      },
    ),
    ad: {
      adDeductionPoint: faker.number.int(),
    },

    requestValues: getServiceOffer(),
    serviceOffer: {
      id: faker.number.int(),
      status: faker.helpers.enumValue(Status),
      values: getServiceOffer(),
    },
  }),
)
